
import { Component, HostListener, Input, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthService } from '@equine-ui-nx/account';
import { Router, RouterModule } from '@angular/router';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { CdkAccordionModule } from '@angular/cdk/accordion';
import { Roles } from '../enums';
import { SeasonDetailService } from 'libs/iea/protocols/season/src/lib/iea-season/season-detail/data-access/season-detail.service';
import { RoleLabelPipe } from '../pipe/role-label.pipe';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FooterComponent } from '../eqform';

interface NavChildRoute {
  name: string;
  link: string;
  type: string;
  icon: string;
  roles?: Roles[];
}

interface NavRoute {
  name: string;
  link: string;
  type: string;
  icon: string;
  roles: Roles[];
  children?: NavChildRoute[];
}

@Component({
  selector: 'eq-wks-nvb',
  standalone: true,
  imports: [
    CommonModule,
    MatToolbarModule,
    MatIconModule,
    MatButtonModule,
    RouterModule,
    MatSidenavModule,
    MatListModule,
    MatMenuModule,
    CdkAccordionModule,
    RoleLabelPipe,
    MatTooltipModule,
    FooterComponent
  ],
  templateUrl: './workspace-navbar.component.html',
  styleUrl: './workspace-navbar.component.scss',
})
export class WorkspaceNavbarComponent implements OnInit {
  @Input() isToolbarShow: boolean = false;
  @ViewChild('sideNav') sideNav!: any;
  isOpenSidnav: boolean = false;
  user: any;
  routLinks: NavRoute[] = [
    {
      name: 'Workspace',
      link: '/dashboard',
      type: 'link',
      icon: 'home',
      roles: [
        Roles.SUPER_ADMIN,
        Roles.ACCOUNT_ADMIN,
        Roles.ZONE_ADMIN,
        Roles.ADMIN,
      ],
    },
    {
      name: 'Account Profile',
      link: '/profile',
      type: 'link',
      icon: 'account_circle',
      roles: [
        Roles.SUPER_ADMIN,
        Roles.ACCOUNT_ADMIN,
        Roles.ZONE_ADMIN,
        Roles.ADMIN,
      ],
    },
    {
      name: 'Admin',
      link: '/#',
      type: 'link',
      icon: 'admin_panel_settings',
      roles: [
        Roles.SUPER_ADMIN,
        Roles.ACCOUNT_ADMIN
      ],
      children: [
        {
          name: 'Manage Admins',
          link: '/admins/manage-team',
          type: 'link',
          icon: '',
          roles: [Roles.SUPER_ADMIN, Roles.ACCOUNT_ADMIN],
        },
        {
          name: "Coupons",
          link: '/coupons',
          type: 'link',
          icon: '',
          roles: [Roles.SUPER_ADMIN, Roles.ACCOUNT_ADMIN],
        },
        {
          name: 'Support Tickets',
          link: '/admins/support-tickets',
          type: 'link',
          icon: '',
          roles: [ Roles.SUPER_ADMIN, Roles.ACCOUNT_ADMIN],
        },
        {
          name: 'ArenaEQ Shows',
          link: '/admins/arena-eq-shows',
          type: 'link',
          icon: '',
          roles: [Roles.SUPER_ADMIN],
        }
      ],
    },
    {
      name: 'Applications',
      link: '/#',
      type: 'link',
      icon: 'list_alt',
      roles: [
        Roles.SUPER_ADMIN,
        Roles.ACCOUNT_ADMIN,
        Roles.ZONE_ADMIN,
        Roles.ADMIN,
      ],
      children: [
        {
          name: 'Member Applications',
          link: '/application-list/membership',
          type: 'link',
          icon: '',
        },
        {
          name: 'Team Applications',
          link: '/application-list/team',
          type: 'link',
          icon: '',
        },
        {
          name: 'Show Host Applications',
          link: '/application-list/show',
          type: 'link',
          icon: '',
        },
      ],
    },
    {
      name: 'Seasons',
      link: '/seasons',
      type: 'link',
      icon: 'calendar_month',
      roles: [
        Roles.SUPER_ADMIN,
        Roles.ACCOUNT_ADMIN
      ],
    },
    {
      name: 'Teams',
      link: '/assets/teams/list',
      type: 'link',
      icon: 'group',
      roles: [
        Roles.SUPER_ADMIN,
        Roles.ACCOUNT_ADMIN,
        Roles.ADMIN,
        Roles.ZONE_ADMIN,
      ],
    },
    {
      name: 'Members',
      link: '/member-data/member-list',
      type: 'link',
      icon: 'person_check',
      roles: [
        Roles.SUPER_ADMIN,
        Roles.ACCOUNT_ADMIN,
        Roles.ADMIN,
        Roles.ZONE_ADMIN
      ],
    },
    {
      name: 'Shows',
      link: '/shows/assets/list',
      type: 'link',
      icon: 'workspace_premium',
      roles: [
        Roles.SUPER_ADMIN,
        Roles.ACCOUNT_ADMIN,
        Roles.ADMIN,
      ],
    },
    {
      name: 'Shows',
      link: '/shows/assets/list',
      type: 'link',
      icon: 'workspace_premium',
      roles: [
        Roles.ZONE_ADMIN,
      ],
    },
    {
      name: 'Performance',
      link: '/#',
      icon: 'workspace_premium',
      type: 'link',
      roles: [Roles.ACCOUNT_ADMIN, Roles.ZONE_ADMIN, Roles.ADMIN, Roles.SUPER_ADMIN],
      children: [
        {
          name: "Points & Results",
          link: "/performance/pr-search",
          icon: "",
          type: "link",
          roles: [Roles.ACCOUNT_ADMIN, Roles.ZONE_ADMIN, Roles.ADMIN, Roles.SUPER_ADMIN],
        },
      ]
    },
    {
      name: 'Utility',
      link: '/#',
      type: 'link',
      icon: 'admin_panel_settings',
      roles: [Roles.SUPER_ADMIN, Roles.ACCOUNT_ADMIN, Roles.ADMIN, Roles.ZONE_ADMIN],
      children: [
        {
          name: "User's Team",
          link: '/admins/user-team',
          type: 'link',
          icon: '',
        },
        {
          name: "Application Status",
          link: '/admins/application-status',
          type: 'link',
          icon: '',
        },
        {
          name: "Rider History",
          link: '/admins/rider-history',
          type: 'link',
          icon: '',
        },
        {
          name: "Insurance",
          link: '/admins/insurance-update',
          type: 'link',
          icon: '',
        },
        {
          name: "Status Engine",
          link: '/admins/status-update',
          type: 'link',
          icon: '',
        },
        {
          name: "Rider-Entries",
          link: '/admins/rider-entries',
          type: 'link',
          icon: '',
        },
        {
          name: "Group Shows",
          link: '/admins/group-shows',
          type: 'link',
          icon: '',
        },
        {
          name: "Merge User Accounts",
          link: '/admins/merge-user-accounts',
          type: 'link',
          icon: '',
        },
        {
          name: "Email Management",
          link: '/admins/notifications',
          type: 'link',
          icon: '',
        },
        {
          name: "Generate Reports",
          link: '/admins/generate-reports',
          type: 'link',
          icon: '',
        }
      ],
    }
  ];
  @Input() showOneEquineLogoInFooter: boolean = true;
  loggedInUserName: string = '';
  role: any = '';
  profilePic: string = '';
  seasonList: any = []
  selectedSeason: any;
  windowMode: any = 'side';

  constructor(
    public authService: AuthService, 
    private router: Router,
    private seasonDetailService: SeasonDetailService
  ) {}

  ngOnInit(): void {
    this.authService.listenToLoggedinUser().subscribe((user: any) => {
      if (user) {
        this.user = user;
        this.loggedInUserName = `${this.user?.firstName} ${this.user?.lastName}`;
        this.loggedInUserName = this.loggedInUserName.toUpperCase();
        this.isOpenSidnav = true;
        this.role = this.user?.roles[0].name

        this.getProfilePic();
        if(!this.profilePic && user?.profilePic) {
          this.authService.getSecuredUrl(user.profilePic).subscribe({
            next: (data)=>{
              this.profilePic = data.url;
              this.authService.setProfilePicUrl(data.url);
            }
          })
        }
        this.getAllSeason({});
      } else {
        this.seasonList = [];
        this.selectedSeason = null;
        this.authService.emitSelectedSeason(null);
      }
    });
    this.setWindowMode(window.innerWidth);
  }
  login() {
    this.router.navigate(['/account/login']);
  }

  getProfilePic(): void {
    this.authService.getProfilePicUrl()
      .subscribe((data: any) => {
        this.profilePic = data;
      });
  }

  async logout(id: any) {
    let refreshToken = await this.authService.getAccessToken();
    let userData = await this.authService.getUserData();
    let accessToken = await this.authService.getAccessToken();

    let data = {
      accessToken: accessToken,
      selectedValue: id,
    };
    this.authService.tokenUpdate(data).subscribe((res) => {
      return res;
    });
    if (accessToken) {
      this.authService.removeAccessToken();
    }
    if (refreshToken) {
      this.authService.removeRefreshToken();
    }
    if (userData) {
      this.authService.removeUserData();
      this.authService.removeUserPermission();
    }
    if (this.authService.getURL()) {
      this.authService.removeCacheUrl();
    }

    //make isloginstatus as false at logout
    this.authService.setIsUserLogin(false);
    this.router.navigate(['/account/login']);
    this.authService.logout();
    this.router.navigate(['/account/login']);
    this.sideNav?.toggle();
  }
  getAllSeason(query: any) {
    query.aggregate =  true;
    query.limit = 50;
    query.excludeIncomplete = true;
    query.excludeFutureInactive = true;
    query.sort = "byName";
    this.seasonDetailService.listAllSeason(query).subscribe({
      next: (res: any) => {
        if (!this.authService.getLoggedInUser()) {
          return;
        }
        this.seasonList = res.data;
        const activeSeason = this.seasonList.find((season: any) => season.status === "active" && season.isActive);
        this.onChangeSeason(activeSeason ? activeSeason: this.seasonList[0]);
      },
    });
  }
  onChangeSeason(activeSeason: any, forceUpdate: boolean = false) {
    const selectedSeason = localStorage.getItem('selectedSeason');
    if (!forceUpdate && selectedSeason && Object.keys(JSON.parse(selectedSeason)).length) {
      const seasonData = this.seasonList.find((season: any) => season._id === JSON.parse(selectedSeason)?._id);
      if (seasonData) activeSeason = seasonData;
    }
    this.selectedSeason = activeSeason;
    this.authService.emitSelectedSeason(this.selectedSeason);
    localStorage.setItem('selectedSeason', JSON.stringify(activeSeason));
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    const target = event.target as Window;
    this.windowMode = (target.innerWidth < 768) ? 'over' : 'side';
  }

  private setWindowMode(innerWidth: number): void {
    this.windowMode = (innerWidth < 768) ? 'over' : 'side';
  }

  goToTransactions() {
    this.router.navigate(['transactions']);
  }

  goToCalendar(): void {
    this.router.navigate(['shows', 'calendar']);
  }

  goToReporting(): void {
    this.router.navigate(['reporting', 'all-reporting']);
  }

  goToProfile(): void {
    this.router.navigate(['/profile']);
  }
}